module.exports = __webpack_public_path__ + "static/usecase_phone@2x-0644495351252f6c938056351a11de07.png";